// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiApplicationMcpTransportSchema = z.enum(['STDIO','SSE','HTTP'] as const);

export type AiApplicationMcpTransportType = `${z.infer<typeof AiApplicationMcpTransportSchema>}`

export default AiApplicationMcpTransportSchema;
